export default {"src":"/_next/static/media/no-data.ba739b11.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};